import ApiClient from '../ApiClient';

class AfricasTalkingChannel extends ApiClient {
  constructor() {
    super('channels/africas_talking_channel', { accountScoped: true });
  }
}

export default new AfricasTalkingChannel();
